import { render, staticRenderFns } from "./HistorialImagenesLabs.vue?vue&type=template&id=20f41b82"
import script from "./HistorialImagenesLabs.vue?vue&type=script&lang=js"
export * from "./HistorialImagenesLabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports